import cn from 'classnames';
import * as React from 'react';

import * as styles from './OfferPreviewModal.css';
import { PortalWrapper } from '../../../../containers/PortalWrapper';
import { ESwipeModalMode, SwipeModal } from '../../../../containers/SwipeModal';

export interface IOfferPreviewModalProps {
  children: React.ReactNode;
  className?: string;
  isOpen: boolean;
  onClose(): void;
}

export const OfferPreviewModal = ({ children, className, isOpen, onClose }: IOfferPreviewModalProps) => {
  return (
    <PortalWrapper>
      <SwipeModal
        className={cn(styles['root'], className)}
        show={isOpen}
        hasOverlay={false}
        mode={ESwipeModalMode.CONTENT}
        testId="OfferPreviewModal"
        onClose={onClose}
      >
        {children}
      </SwipeModal>
    </PortalWrapper>
  );
};

OfferPreviewModal.displayName = 'OfferPreviewModal';
